import { useEffect, useState } from 'react';
import { t } from '../i18n/idioma';
import { relogio } from './dueloTempo';

/** O aviso do servidor (evento `ResBloqueio`), com a hora em que chegou para contar o criminal no cliente. */
export interface ResBloqueioView {
  notoriedade: number;
  segundos: number;
  mortes: number;
  cidade: string;
  cidadeLivre: string;
  recebidoEm: number;
}

interface Props {
  aviso: ResBloqueioView;
  ocupado: boolean;
  onCove(): void;
  onReviver(): void;
  onFechar(): void;
}

/**
 * Criminoso ou assassino não revive em cidade com guarda (Renato, 26/10/2026). Mostra o estado (o tempo até voltar
 * a inocente, ou as mortes do assassino) e a escolha: reviver em Cove, a cidade sem guarda, ou esperar.
 */
export function ResBloqueioAviso({ aviso, ocupado, onCove, onReviver, onFechar }: Props) {
  const criminoso = aviso.notoriedade === 1;
  const [agora, setAgora] = useState(() => Date.now());
  useEffect(() => {
    if (!criminoso) return;
    const id = window.setInterval(() => setAgora(Date.now()), 500);
    return () => window.clearInterval(id);
  }, [criminoso]);

  const falta = aviso.recebidoEm + aviso.segundos * 1000 - agora;
  const livre = criminoso && falta <= 0;

  return (
    <div className="ress-aviso" role="alertdialog" aria-labelledby="ress-aviso-titulo">
      <h3 id="ress-aviso-titulo" className="ress-aviso__titulo">
        {livre ? t('ress.bloqueio.livreTitulo') : t('ress.bloqueio.titulo', { cidade: aviso.cidade })}
      </h3>
      {livre ? (
        <p className="ress-aviso__texto">{t('ress.bloqueio.livre', { cidade: aviso.cidade })}</p>
      ) : criminoso ? (
        <p className="ress-aviso__texto">
          {t('ress.bloqueio.criminoso')}{' '}
          <b className="ress-aviso__tempo">{t('ress.bloqueio.inocenteEm', { tempo: relogio(falta) })}</b>
        </p>
      ) : (
        <p className="ress-aviso__texto">{t('ress.bloqueio.assassino', { mortes: aviso.mortes })}</p>
      )}
      {!livre && <p className="ress-aviso__texto ress-aviso__texto--suave">{t('ress.bloqueio.opcao', { cidade: aviso.cidadeLivre })}</p>}
      <div className="ress-aviso__acoes">
        {livre ? (
          <button type="button" className="ress-bar__btn" disabled={ocupado} onClick={onReviver}>{t('ress.botao')}</button>
        ) : (
          <button type="button" className="ress-bar__btn" disabled={ocupado} onClick={onCove}>
            {t('ress.bloqueio.irCove', { cidade: aviso.cidadeLivre })}
          </button>
        )}
        <button type="button" className="btn btn--ghost btn--tiny" onClick={onFechar}>
          {livre ? t('comum.fechar') : t('ress.bloqueio.esperar')}
        </button>
      </div>
    </div>
  );
}
